import { createContext, useContext, useState, useLayoutEffect } from "react";

const VALID_ZOOM_VALUES = [100, 90, 80];
const DEFAULT_ZOOM = 90;

const getZoomFromUser = () => {
  try {
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      const user = JSON.parse(storedUser);
      if (VALID_ZOOM_VALUES.includes(user.displayZoom)) {
        return user.displayZoom;
      }
    }
  } catch {}
  return DEFAULT_ZOOM;
};

const AppZoomContext = createContext(null);

export const AppZoomProvider = ({ children }) => {
  const [zoomLevel, setZoomLevelState] = useState(getZoomFromUser);

  useLayoutEffect(() => {
    setZoomLevelState(getZoomFromUser());
  }, []);

  const setZoomLevel = (value) => {
    if (!VALID_ZOOM_VALUES.includes(value)) return;
    try {
      const storedUser = localStorage.getItem("user");
      if (storedUser) {
        const user = JSON.parse(storedUser);
        user.displayZoom = value;
        localStorage.setItem("user", JSON.stringify(user));
      }
    } catch {}
    setZoomLevelState(value);
  };

  return (
    <AppZoomContext.Provider value={{ zoomLevel, setZoomLevel }}>
      {children}
    </AppZoomContext.Provider>
  );
};

export const useAppZoom = () => {
  const ctx = useContext(AppZoomContext);
  if (!ctx) return { zoomLevel: DEFAULT_ZOOM, setZoomLevel: () => {} };
  return ctx;
};
